import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import axios from "axios";

import Footer from "../ComponentPrimer/Footer";

const CekDataPendaftar = () => {
  const [phone, setPhone] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [isRegistered, setIsRegistered] = useState(false);
  const [message, setMessage] = useState("");

  const toggleModal = () => setModalOpen(!modalOpen);

  const handlePhoneChange = (e) => {
    let input = e.target.value.replace(/^\+/, ""); // Hapus simbol +
    if (input.startsWith("0")) {
      input = "62" + input.slice(1); // Ganti angka 0 di depan dengan 62
    }
    setPhone(input);
  };

  const checkPhone = async () => {
    try {
      const response = await axios.post("https://app.rlagency.id/apiopenhouse/check-pendaftar.php", { phone });
      if (response.data.exists) {
        setFormData(response.data.userData);
        setIsRegistered(true);
      } else {
        setMessage("Kamu belum terdaftar. Silahkan melakukan pedaftaran terlebih dahulu atau hubungi panitia untuk info lebih lanjut.");
        setIsRegistered(false);
      }
      setModalOpen(true);
    } catch (error) {
      console.error("Error checking phone:", error);
      setMessage("Terjadi kesalahan saat memproses data. Silahkan coba lagi.");
      setModalOpen(true);
    }
  };

  const downloadIDCardAsImage = () => {
    const modalContent = document.getElementById("modal-content");
    html2canvas(modalContent).then((canvas) => {
      const imageUrl = canvas.toDataURL("image/jpeg");
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `${formData.nama}-OpenHouseUpi.jpg`;
      link.click();
    });
  };

  return (
    <div
    style={{
        display: "flex", 
        justifyContent: 'space-between', 
        alignItems: "center", 
        height: "100vh",
        flexDirection:'column', 
        margin: "0 auto" 
    }}
    >
    <div style={{margin:'20px auto', maxWidth:'800px', padding:'20px'}}>
      <h3 style={{fontSize:'24px', fontWeight:'600', textTransform:'uppercase', fontStyle:'italic'}}>Cek QR Code Open House UPI YPTK Padang</h3>
      <hr style={{padding:'0', margin:'0px 0px 15px 0px'}}/>
      <small>Isikan dengan No HP yang kamu daftarkan. Isi dengan format yang benar. Contoh : 62852xxxxxxxx</small>
      <input
        type="text"
        value={phone}
        onChange={handlePhoneChange}
        placeholder="628xxxxx"
        style={{ width: "100%", padding: "10px", marginBottom: "10px", borderRadius:'5px', border:'solid', borderWidth:'1px', borderColor:'#ddd' }}
      />
      <Button color="primary" onClick={checkPhone} style={{width:'100%'}}>
        Cek QR
      </Button>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="sm" centered>
        {isRegistered ? (
          <>
            <ModalHeader toggle={toggleModal}>Sudah Terdaftar</ModalHeader>
            <ModalBody
              id="modal-content"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <div
                style={{
                  width: "300px",
                  border: "1px solid #000",
                  padding: "20px 0px",
                  textAlign: "center",
                  borderRadius: "10px",
                }}
              >
                <div>
                  <h5
                    style={{
                      padding: "0px",
                      margin: "0px",
                      fontSize: "20px",
                      textTransform: "uppercase",
                      fontWeight: "500",
                    }}
                  >
                    {formData.nama}
                  </h5>
                  <p
                    style={{
                      padding: "0px",
                      margin: "0px",
                      color: "#1b1b1b",
                      fontSize: "15px",
                      textTransform: "uppercase",
                    }}
                  >
                    {formData.school}
                  </p>
                  <hr
                    style={{
                      padding: "0px",
                      margin: "10px auto",
                      width: "70%",
                      borderColor: "#1b1b1b",
                    }}
                  />
                </div>
                <div style={{ marginTop: "30px" }}>
                  <QRCodeCanvas value={formData.qrcodeData.toString()} />
                </div>
                <div>
                  <p
                    style={{
                      padding: "0px 30px",
                      marginTop: "20px",
                      color: "#1b1b1b",
                      fontSize: "13px",
                    }}
                  >
                    *Simpan/ Screenshoot QR Code agar kamu diizinkan memasuki
                    venue/ gedung acara.
                  </p>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                style={{ width: "100%", fontSize: "16px" }}
                color="primary"
                onClick={downloadIDCardAsImage}
              >
                Download QR
              </Button>
            </ModalFooter>
          </>
        ) : (
          <>
            <ModalHeader toggle={toggleModal}>Kamu Belum Terdaftar</ModalHeader>
            <ModalBody>{message}</ModalBody>
          </>
        )}
      </Modal>
    </div>
        <Footer />
    </div>
  );
};

export default CekDataPendaftar;
